import * as agendas from './agendas'

export default {
  ...agendas
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/store/actions/index.js